module.exports = __webpack_public_path__ + "static/media/logoLeparc.de19d411.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/logoLeparc.png
// module id = 1160
// module chunks = 0